module.exports = __webpack_public_path__ + "static/media/texture-triangle.d86dcf78.png";